import { resolveDecision } from "cookiesConsent/features/resolveConsent"
import { seedGtmFromVisitor } from "cookiesConsent/features/bootGtm"
import { persistedC15tConsent } from "cookiesConsent/infrastructure/c15t/consent/persistedC15tConsent"
import { exposeAnalyticsBuffer } from "cookiesConsent/infrastructure/segment/startDeferredSegment"
import { analyticsActivation } from "cookiesConsent/infrastructure/segment/AnalyticsActivation"

export const bootDeferredAnalytics = (): void => {
  exposeAnalyticsBuffer()
  // Seed Google Consent Mode from the visitor's persisted (or jurisdiction-
  // default) consent before analytics can start loading: the update is queued
  // on the dataLayer ahead of gtag.js, and a stored update outranks the denied
  // `default` the GA4 destination sets at initialisation, regardless of order.
  seedGtmFromVisitor()
  resolveDecision(persistedC15tConsent()).whenDecided(analyticsActivation.start)
}
